module.exports = __webpack_public_path__ + "img/brand-04.21847b84.png";